import { differenceInDays, format, isYesterday } from 'date-fns'
import localeNL from 'date-fns/locale/nl'

interface FormattedTimeProps {
    date?: string | Date | null
    format?: string
}

const getDate = (value?: string | Date | null): Date => {
    if (!value) return new Date(0)
    if (value instanceof Date) return value
    return new Date(value.replace(' ', 'T'))
}

const FormattedTime = ({ date, format: formatStr }: FormattedTimeProps) => {
    const parsedDate = getDate(date)

    if (formatStr) {
        return <>{format(parsedDate, formatStr, { locale: localeNL })}</>
    }

    if (isYesterday(parsedDate)) {
        return <>{format(parsedDate, 'd MMM HH:mm')}</>
    }

    const daysAgo = differenceInDays(new Date(), parsedDate)
    const pattern = (() => {
        if (daysAgo === 0) return 'HH:mm'
        if (daysAgo < 8) return 'd MMM HH:mm'
        return 'd MMM yyyy'
    })()

    return <>{format(parsedDate, pattern, { locale: localeNL })}</>
}

export default FormattedTime
